
export enum AberdeenshireRecordType {
    Monument = "mon",
    Event = "event",
    Source = "source",
    Designation = "desig"
}

export enum AberdeenshireRecordSubType  {   
    ConservationArea = "COA",
    ListedBuilding = "LB",
    GardensAndDesignedLandscapes = "GDL",
    Battlefields = "B",
    ScheduledMonument = "SAM"
}  

